(() => {
  "use strict";

  const button = document.querySelector("[data-back-to-top]");
  if (!button) return;

  const SETTINGS = {
    showAfter: 400,
    minDuration: 350,
    maxDuration: 1100,
    millisecondsPerPixel: 0.45,
  };

  const root = document.documentElement;
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let scrollFrame = 0;
  let visibilityFrame = 0;
  let previousInlineScrollBehavior = "";
  let controlsScrollBehavior = false;

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const easeOutQuint = (progress) => 1 - Math.pow(1 - progress, 5);

  function takeScrollControl() {
    previousInlineScrollBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = "auto";
    controlsScrollBehavior = true;
  }

  function releaseScrollControl() {
    if (!controlsScrollBehavior) return;
    root.style.scrollBehavior = previousInlineScrollBehavior;
    controlsScrollBehavior = false;
  }

  function cancelAutomaticScroll() {
    if (scrollFrame) cancelAnimationFrame(scrollFrame);
    scrollFrame = 0;
    releaseScrollControl();
  }

  function updateVisibility() {
    visibilityFrame = 0;
    button.classList.toggle("is-visible", window.scrollY >= SETTINGS.showAfter);
  }

  function requestVisibilityUpdate() {
    if (!visibilityFrame) {
      visibilityFrame = requestAnimationFrame(updateVisibility);
    }
  }

  function scrollToTop() {
    cancelAutomaticScroll();

    const startY = Math.max(0, window.scrollY);
    if (startY === 0) return;

    // Reduced motion bypasses the full-viewport animation.
    if (reducedMotion.matches) {
      takeScrollControl();
      window.scrollTo(0, 0);
      releaseScrollControl();
      return;
    }

    const duration = clamp(
      startY * SETTINGS.millisecondsPerPixel,
      SETTINGS.minDuration,
      SETTINGS.maxDuration,
    );
    const startTime = performance.now();

    takeScrollControl();

    function animate(currentTime) {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const easedProgress = easeOutQuint(progress);
      const nextY = Math.max(0, startY * (1 - easedProgress));

      window.scrollTo(0, nextY);

      if (progress < 1 && window.scrollY > 0) {
        scrollFrame = requestAnimationFrame(animate);
        return;
      }

      window.scrollTo(0, 0);
      scrollFrame = 0;
      releaseScrollControl();
    }

    scrollFrame = requestAnimationFrame(animate);
  }

  button.addEventListener("click", scrollToTop);
  window.addEventListener("scroll", requestVisibilityUpdate, { passive: true });
  window.addEventListener("wheel", cancelAutomaticScroll, { passive: true });
  window.addEventListener("touchstart", cancelAutomaticScroll, { passive: true });
  window.addEventListener("keydown", cancelAutomaticScroll);
  window.addEventListener("pagehide", cancelAutomaticScroll);

  const handleReducedMotionChange = () => {
    if (reducedMotion.matches && scrollFrame) {
      cancelAutomaticScroll();
      takeScrollControl();
      window.scrollTo(0, 0);
      releaseScrollControl();
    }
  };

  if (typeof reducedMotion.addEventListener === "function") {
    reducedMotion.addEventListener("change", handleReducedMotionChange);
  } else {
    reducedMotion.addListener(handleReducedMotionChange);
  }

  updateVisibility();
})();
